let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7ZaF9")).then(() => parcelRequire('kI1gl'));